import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=a5043564&scoped=true"
import script from "./SideMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./SideMenu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SideMenu.vue?vue&type=style&index=0&id=a5043564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5043564",
  null
  
)

export default component.exports